// API configuration
// Override via environment variable REACT_APP_API_URL at build time
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.saturnmail.cc';

export const API = {
  VALIDATE_TOKEN: (token) => `${API_BASE_URL}/api/v1/public/validate_token/${token}`,
  CHANGE_PASSWORD: `${API_BASE_URL}/api/v1/public/change_password`,
};
